import { Application } from "@hotwired/stimulus"
import { registerControllers } from "stimulus-vite-helpers"
import Notification from "@stimulus-components/notification"
import Dropdown from "@stimulus-components/dropdown"

const application = Application.start()

const controllers = import.meta.glob("./**/*_controller.ts", { eager: true })
registerControllers(application, controllers)

application.register("notification", Notification)
application.register("dropdown", Dropdown)
